import { library } from '@fortawesome/fontawesome-svg-core';

import * as icons from '@fortawesome/free-solid-svg-icons';

const myIcons = [
    'faClipboardList',
    'faArrowAltCircleRight',
    'faCheck',
    'faPencilAlt',
    'faClone',
    'faEye',
    'faEyeSlash',
    'faFileExcel',
    'faFilePdf',
    'faCogs',
    'faExchangeAlt',
    'faPowerOff',
    'faLock',
    'faSearch',
    'faCircle',
    'faCheckCircle',
    'faTrashAlt',
    'faPlus',
    'faBan',
    'faTimesCircle',
    'faUserCheck',
    'faBox',
    'faUserCircle',
    'faListAlt',
    'faTimes',
    'faPrint',
    'faReceipt',
    'faTags',
    'faInfoCircle',
    'faMailBulk',
    'faWarehouse',
    'faColumns',
    'faFileContract',
    'faBoxOpen',
    'faShoppingBag',
    'faTasks',
    'faUserCog',
    'faUndoAlt',
    'faRunning',
    'faUsers',
    'faAngleDoubleLeft',
    'faAngleDoubleRight',
    'faFilter',
    'faRedo',
    'faSync',
    'faCalendarCheck',
    'faBoxes',
    'faFile',
    'faFileAlt',
    'faShare',
    'faEnvelopeOpenText',
    'faSignOutAlt',
    'faEllipsisV',
    'faCashRegister',
    'faArrowCircleLeft',
    'faArrowsAlt',
    'fas',
];

myIcons.forEach(function(item) {
    library.add(icons[item]);
});